import { PAGE_DIFF_BY_VERSION } from '@confluence/named-routes/entry-points/routes';
import { CONTEXT_PATH } from '@confluence/named-routes/entry-points/context';

import type {
	FeedCardAllActivityQuery_pageActivity_nodes as PageActivity,
	FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventUpdatedPage as PageActivity_UpdatedPage,
	FeedCardAllActivityQuery_pageActivity_nodes_PageActivityEventCreatedComment as PageActivity_CreatedComment,
} from './__types__/FeedCardAllActivityQuery';
import {
	PageActivityAction,
	PageActivityActionSubject,
} from './__types__/FeedCardAllActivityQuery';

// We map PageActivityActionSubject to more closely match FeedContentQuery's FeedEventType
// because the FE displays them the same by ActivityLineUpdateLink, even though these are used for Recent Actions and FeedEventType is used for the feed card itself.
const supportedUpdateTypes = {
	[PageActivityActionSubject.page]: {
		[PageActivityAction.created]: 'CREATE', // normal page has been created
		[PageActivityAction.started]: 'CREATE', // live page has been created
		[PageActivityAction.updated]: 'EDIT', // normal page has been updated
		[PageActivityAction.snapshotted]: 'EDITLIVE', // live page snapshotted (version update)
		[PageActivityAction.published]: 'PUBLISHLIVE', // live page converted to published page
	},
	[PageActivityActionSubject.comment]: {
		[PageActivityAction.created]: 'COMMENT',
	},
};
type SupportedType = 'COMMENT' | 'CREATE' | 'EDIT' | 'EDITLIVE' | 'PUBLISHLIVE' | undefined;
export const getSupportedUpdateType = (
	actionSubject: PageActivityActionSubject,
	action: PageActivityAction,
): SupportedType => {
	return supportedUpdateTypes[actionSubject]?.[action];
};

type Photo = {
	value: string | null;
	isPrimary: boolean | null;
};
type UserPhotos = (Photo | null)[] | null;
export const getAvatarUrl = (photos: UserPhotos): string => {
	return photos?.find((photo) => photo?.isPrimary)?.value || '';
};

export const getUpdateContentUrl = (
	activity: PageActivity,
	contentUrl: string,
	contentId: string,
): string => {
	const type = getSupportedUpdateType(activity.actionSubject, activity.action);
	if (type === 'COMMENT') {
		const commentLink = (activity as PageActivity_CreatedComment).comment.links.webui;
		if (commentLink) {
			return `${CONTEXT_PATH}${commentLink}`;
		}
	}

	if (type === 'CREATE' || type === 'PUBLISHLIVE') {
		return contentUrl;
	}

	if (type === 'EDIT' || type === 'EDITLIVE') {
		const version = (activity as PageActivity_UpdatedPage).pageVersion;
		const params = {
			query: {
				pageId: contentId,
				selectedPageVersions: [version, version - 1],
			},
		};
		return PAGE_DIFF_BY_VERSION.toUrl({}, params);
	}

	return '';
};
